module.exports = __webpack_public_path__ + "static/media/102.71d28f27.png";